import React, { useEffect, useState } from 'react';
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Input,
  Form,
  Space,
  Button,
  Drawer
} from '@lockerpm/design';
import {
} from '@ant-design/icons';

import workspaceServices from '../../../../../services/workspace';

import storeActions from '../../../../../store/actions';
import global from '../../../../../config/global';

function FormData(props) {
  const { t } = useTranslation()
  const {
    visible = false,
    workspace = null,
    onClose = () => {},
  } = props
  const [form] = Form.useForm()
  const [callingAPI, setCallingAPI] = useState(false);

  const name = Form.useWatch('name', form)

  useEffect(() => {
    if (workspace) {
      form.setFieldsValue({
        name: workspace.name,
        description: workspace.description
      })
    }
  }, [workspace])

  const handleSave = async () => {
    form.validateFields().then(async (value) => {
      setCallingAPI(true);
      await workspaceServices.update(workspace.id, value).then(async () => {
        const workspaces = await workspaceServices.list({ paging: 0 }) || [];
        global.store.dispatch(storeActions.updateWorkspaces(workspaces));
        global.store.dispatch(storeActions.updateSelectedWorkspace(workspaces.find((w) => w.id === workspace.id)))
        global.notification('success', t('notification.success.title'), t('notification.success.workspace.updated'));
        handleClose();
      }).catch((error) => {
        global.pushError(error)
      })
      setCallingAPI(false);
    })
  }


  const handleClose = () => {
    form.resetFields();
    onClose()
  }

  return (
    <div className={props.className}>
      <Drawer
        title={t('workspaces.edit')}
        placement="right"
        onClose={handleClose}
        open={visible}
        footer={
          <Space className='flex items-center justify-end'>
            <Button
              disabled={callingAPI}
              onClick={handleClose}
            >
              {t('button.cancel')}
            </Button>
            <Button
              type="primary"
              disabled={!name || !name.trim()}
              loading={callingAPI}
              onClick={handleSave}
            >
            { t('button.save') } 
            </Button>
          </Space>
        }
      >
        <Form
          form={form}
          layout="vertical"
          labelAlign={'left'}
        >
          <Form.Item
            name={'name'}
            label={<div>
              <p className='font-bold'>{t('information.workspace_name')}</p>
              <span>{t('information.workspace_name_description')}</span>
            </div>}
            rules={[
              global.rules.REQUIRED(t("information.workspace_name")),
            ]}
          >
            <Input
              size="medium"
              disabled={callingAPI}
              className='w-full'
              placeholder={t('placeholder.enter')}
            />
          </Form.Item>
          <Form.Item
            name={'description'}
            label={t('common.description')}
            rules={[]}
          >
            <Input.TextArea
              disabled={callingAPI}
              className='w-full'
              placeholder={t('placeholder.enter')}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
}

export default FormData;
